import moment from 'moment';

export function formatDay(day: Date, locale = 'en'): string {
  return moment(day).locale(locale).format('ddd ll');
}

export function formatMonthTitle(date: Date, locale = 'en'): string {
  return moment(date).locale(locale).format('MMMM YYYY');
}

export function formatFutureMonthTitle(date: Date, locale = 'en'): string {
  const futureMonth = moment(date).add(1, 'M').toDate();
  return formatMonthTitle(futureMonth, locale);
}

export function formatWeekdayShort(day: number, locale = 'en'): string {
  const localeData = moment.localeData(locale);
  const lowered = locale.toLowerCase();
  const labels =
    lowered === 'pt' || lowered === 'pt-br' ? localeData.weekdaysShort() : localeData.weekdaysMin();
  return labels[day][0];
}

export function formatWeekdayLong(day: number, locale = 'en'): string {
  return moment.localeData(locale).weekdays()[day];
}

export function getFirstDayOfWeek(locale = 'en'): number {
  return moment.localeData(locale).firstDayOfWeek();
}

type MonthsTuple = [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
];

export function getMonths(locale = 'en'): MonthsTuple {
  const months: string[] = [];
  let i = 0;
  while (i < 12) {
    months.push(moment().locale(locale).month(i).format('MMMM'));
    i += 1;
  }
  return months as MonthsTuple;
}

export function formatDate(date: Date, format: string | string[] = 'L', locale = 'en'): string {
  return moment(date)
    .locale(locale)
    .format(Array.isArray(format) ? format[0] : format);
}

export function parseDate(
  str: string,
  format: string | string[] = 'L',
  locale = 'en',
): Date | undefined {
  const m = moment(str, format, locale, true);
  if (m.isValid()) {
    return m.toDate();
  }
  return undefined;
}
